import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import StarRating from "@/components/StarRating";
import VideoPlayer from "@/components/VideoPlayer";
import { REVIEWS, VIDEOS } from "@/lib/constants";

const VIDEO_REVIEWS = [
  { src: VIDEOS.moringaReview, label: "Moringa Soya Nachos", tag: "Video Review" },
  { src: VIDEOS.modelBeetroot, label: "Beetroot, in the spotlight", tag: "Video Review" },
  { src: VIDEOS.beetroot, label: "Fresh from the jar", tag: "Video Review" },
  { src: VIDEOS.beetroot2, label: "Bold beetroot crunch", tag: "Video Review" },
];

export default function ReviewsSection() {
  return (
    <section id="reviews" className="bg-forest-deep py-24 lg:py-28" data-testid="reviews-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Overline>Word Of Mouth</Overline>
          <h2 className="mt-3 font-display text-5xl leading-none tracking-tight text-cream sm:text-7xl">
            CUSTOMER <span className="text-gold-gradient">REVIEWS</span>
          </h2>
          <p className="mt-3 text-sm text-white/40">
            Real reactions in motion — plus editable placeholder reviews to replace before launch.
          </p>
        </Reveal>

        {/* Video reviews */}
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {VIDEO_REVIEWS.map((v, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              data-testid={`video-review-${i}`}>
              <VideoPlayer src={v.src} label={v.label} tag={v.tag} className="aspect-[9/16]" />
            </motion.div>
          ))}
        </div>

        {/* Text reviews */}
        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {REVIEWS.map((r, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              className="rounded-3xl border border-white/10 bg-black/40 p-6"
              data-testid={`review-card-${i}`}>
              <Quote className="text-gold/50" size={28} />
              <p className="mt-4 text-sm leading-relaxed text-white/70">{r.text}</p>
              <div className="mt-5 border-t border-white/10 pt-4">
                <StarRating rating={r.rating} />
                <div className="mt-2 font-oswald text-sm uppercase tracking-wide text-cream">{r.name}</div>
                <div className="text-xs text-white/40">{r.location}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
